// ─── Tier configuration — single source of truth ──────────────────────────
// Imported by:
//   • api/create-checkout.js    — picks Stripe Price IDs + sets metadata
//   • api/_billing/syncTierFromSubscription.js — writes accounts row
//   • src/components/PaywallTiers.jsx — in-app paywall display
//   • landing/index.html (NOT — the landing is hand-maintained HTML; any
//     drift between TIER_CONFIG and landing copy is caught by the audit
//     test in tests/tierConfigDrift.test.js)
//
// Adding a tier or changing limits → edit ONLY this file.
// Stripe Price IDs (env-only, server-side) live in api/_billing/tierPrices.js.
//
// Conventions:
//   • All limit fields are required and must be numbers (use 9999 for
//     "effectively unlimited" so quota checks don't need special-casing).
//   • Boolean feature flags default to false on new tiers.

export const TIER_IDS = ["starter", "pro", "business"];

export const TIER_CONFIG = {
  starter: {
    label:        "Starter",
    monthlyPrice: 29,
    yearlyPrice:  290,
    trial:        14,         // days
    maxMembers:   3,
    maxBrands:    1,
    aiLimit:      300,        // AI messages per month (across all channels)
    whatsapp:     false,
    telegram:     false,
    notifications: false,     // AI notifications (reorder/payment/stockout)
    auditLog:     false,      // shipped to all tiers regardless — flag kept for parity
    whitelabel:   false,      // logo on PDFs
    attachments:  false,      // PDF/image upload on transactions
    exports:      false,      // CSV/PDF export
  },
  pro: {
    label:        "Pro",
    monthlyPrice: 59,
    yearlyPrice:  590,
    trial:        14,
    maxMembers:   10,
    maxBrands:    3,
    aiLimit:      3000,
    whatsapp:     true,
    telegram:     true,
    notifications: true,
    auditLog:     false,
    whitelabel:   false,
    attachments:  true,
    exports:      true,
  },
  business: {
    label:        "Business",
    monthlyPrice: 99,
    yearlyPrice:  990,
    trial:        14,
    maxMembers:   9999,
    maxBrands:    9999,
    aiLimit:      999999,
    whatsapp:     true,
    telegram:     true,
    notifications: true,
    auditLog:     true,
    whitelabel:   true,
    attachments:  true,
    exports:      true,
  },
};

/** Default tier for new signups (before checkout completes). */
export const DEFAULT_TIER = "starter";

/** Validate a tier id; returns the id or DEFAULT_TIER. */
export function normalizeTier(t) {
  return TIER_IDS.includes(t) ? t : DEFAULT_TIER;
}

/** Read a tier's full config (throws on unknown — call normalizeTier first). */
export function getTierConfig(t) {
  const cfg = TIER_CONFIG[t];
  if (!cfg) throw new Error(`Unknown tier: ${t}`);
  return cfg;
}
